export const getYouTubeID = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);

    // Handle youtube.com/watch?v=ID format
    const vParam = parsedUrl.searchParams.get('v');
    if (vParam) return vParam;

    // Handle youtube.com/embed/ID format
    const embedMatch = parsedUrl.pathname.match(/\/embed\/([^/?]+)/);
    if (embedMatch) return embedMatch[1];

    // Handle youtu.be/ID format
    if (parsedUrl.hostname === 'youtu.be') {
      return parsedUrl.pathname.slice(1);
    }

    return null;
  } catch {
    return null;
  }
};
